import axios from "../util/axios";

export const getDonations = async (
  currentPage,
  search = "",
  paymentStatus = null,
  dateFrom = null,
  dateTo = null,
  amountMin = null,
  amountMax = null
) => {
  try {
    const perPageContent = 10;
    const offset = (+currentPage - 1) * +perPageContent;
    const params = {
      offset,
      limit: perPageContent,
      sort: JSON.stringify([["created_at", "desc"]]),
    };
    const whereCondition = {};

    if (search !== "") {
      params.search = search;
    }

    if (paymentStatus !== null && paymentStatus !== "") {
      whereCondition.payment_status = paymentStatus;
    }

    if (dateFrom) {
      whereCondition.created_at = {
        ...whereCondition.created_at,
        $gte: dateFrom,
      };
    }

    if (dateTo) {
      whereCondition.created_at = {
        ...whereCondition.created_at,
        $lte: dateTo,
      };
    }

    if (amountMin !== null && amountMin !== "") {
      whereCondition.amount = {
        ...whereCondition.amount,
        $gte: parseFloat(amountMin),
      };
    }

    if (amountMax !== null && amountMax !== "") {
      whereCondition.amount = {
        ...whereCondition.amount,
        $lte: parseFloat(amountMax),
      };
    }

    if (Object.keys(whereCondition).length > 0) {
      params.where = JSON.stringify(whereCondition);
    }

    const response = await axios.get("/donation", { params });
    return response?.data?.data;
  } catch (error) {
    throw new Error(error?.response?.data?.error || "Something went wrong");
  }
};

export const getDonation = async (id) => {
  try {
    const response = await axios.get(`/donation/${id}`);
    return response?.data?.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      throw new Error("404");
    } else {
      throw new Error(error?.response?.data?.error || "Something went wrong");
    }
  }
};
